import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Interlink grid for SEO — related keywords, blogs, cities.
 *
 * Props:
 *   links - array of { title, href, description }
 */
const RelatedLinks = ({ links = [] }) => {
  if (links.length === 0) return null;

  return (
    <div className="rr-related-links">
      {links.map((link, i) => (
        <Link key={i} to={link.href} className="rr-related-link">
          <div className="rr-related-link__title">{link.title}</div>
          {link.description && (
            <div className="rr-related-link__desc">{link.description}</div>
          )}
        </Link>
      ))}
    </div>
  );
};

export default RelatedLinks;
